import React, { useState } from "react";
import axios from "axios";
import { Button, Spinner } from "@fluentui/react-components";
 
const DocumentAnalysis = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
 
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
   
        if (!file) {
            setMessage("Please upload a document.");
            return;
        }
   
        // Validate file type for Word documents
        const allowedExtensions = ["doc", "docx"];
        const fileExtension = file.name.split(".").pop().toLowerCase();
   
        if (!allowedExtensions.includes(fileExtension)) {
            setMessage("Invalid file type. Please upload a Word document (.doc or .docx).");
            setSelectedFile(null);
            return;
        }
   
        setSelectedFile(file);
        setMessage("");
    };
   
 
    const handleUploadAndSubmit = async () => {
        if (!selectedFile) {
            setMessage("Please upload a document to analyze.");
            return;
        }
 
        setLoading(true);
        setMessage("");
        const formData = new FormData();
        formData.append("document", selectedFile);
 
        try {
            // Assuming the backend API that processes the file and returns HTML content for Word document
            const response = await axios.post("https://mensreabackend.openteqdev.com/analyze", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
 
            if (response.status === 200 && response.data) {
                setMessage("Content appended to Word document successfully!");
                appendContentToWord(response.data); // Append the analyzed content to Word
                setSelectedFile(null);
            } else {
                setMessage("Error: Empty or invalid API response.");
            }
        } catch (error) {
            console.error(error);
            setMessage("Error: Unable to process the document.");
        } finally {
            setLoading(false);
        }
    };
//working
    // const appendContentToWord = async (htmlContent) => {
    //     try {
    //         //console.log("htmlContent",htmlContent);
    //         await Word.run(async (context) => {
    //             context.document.body.insertHtml(htmlContent, Word.InsertLocation.end);
    //             await context.sync();
    //             console.log("Content successfully appended to Word document.");
    //         });
    //     } catch (error) {
    //         console.error("Error appending content to Word document:", error);
    //         setMessage("Failed to append content to Word document.");
    //     }
    // };
 
    // const appendContentToWord = async (htmlContent) => {
    //     try {
    //         await Word.run(async (context) => {
    //             // Check if there's a current selection
    //             const selection = context.document.getSelection();
    //             selection.insertHtml(htmlContent, Word.InsertLocation.replace); // Inserts content at the cursor position
    //             await context.sync();
    //             console.log("Content successfully appended at the cursor position in Word document.");
    //         });
    //     } catch (error) {
    //         console.error("Error appending content to Word document:", error);
    //         setMessage("Failed to append content to Word document.");
    //     }
    // };
    const appendContentToWord = async (htmlContent) => {
        try {
            await Word.run(async (context) => {
                // Check if there's a current selection
                const selection = context.document.getSelection();

                //format the content 
                const updatedContent = processContent(htmlContent);
     
                // Insert the provided HTML content at the current selection
                selection.insertHtml(updatedContent, Word.InsertLocation.replace);
                await context.sync();
     
                // Load all paragraphs in the document
                // const paragraphs = context.document.body.paragraphs;
                // paragraphs.load("items");
     
                // await context.sync();
     
                // // Iterate through the paragraphs and adjust alignment or apply Roman numeral formatting
                // paragraphs.items.forEach((para) => {
                //     if (para.text.includes("....")) { // Example placeholder for alignment
                //         para.alignment = Word.Alignment.justify; // Align the paragraph to the right
                //     }
                // });
     
                // await context.sync();
     
                console.log("Content successfully appended and formatted in the Word document.");
            });
        } catch (error) {
            console.error("Error appending content to Word document:", error);
        }
    };
   
     
   
    const traverseAndAppend = (sourceNode, targetRange) => {
        Array.from(sourceNode.childNodes).forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                const cleanedText = node.textContent.replace(/\s+/g, " ").trim(); // Normalize text globally
                if (!cleanedText) return; // Skip empty content
 
                switch (node.tagName) {
                    case "H1":
                        targetRange.insertParagraph(cleanedText, Word.InsertLocation.before).font.set({
                            bold: true,
                            size: 16,
                        });
                        break;
                    case "H2":
                        targetRange.insertParagraph(cleanedText, Word.InsertLocation.before).font.set({
                            bold: true,
                            size: 14,
                        });
                        break;
                    case "P":
                        targetRange.insertParagraph(cleanedText, Word.InsertLocation.before).font.set({
                            size: 12,
                            bold: false,
                        });
                        break;
                    case "UL":
                        traverseAndAppend(node, targetRange); // Process list items recursively
                        break;
                    case "LI":
                        targetRange.insertParagraph(`• ${cleanedText}`, Word.InsertLocation.before).font.set({
                            size: 12,
                            bold: false,
                        });
                        break;
                    default:
                        targetRange.insertParagraph(cleanedText, Word.InsertLocation.before).font.set({
                            size: 12,
                        });
                        break;
                }
            }
        });
    };
    // const insertTOC = async () => {
    //     try {
    //       await Word.run(async (context) => {
    //         const body = context.document.body;
     
    //         // Load all paragraphs to identify valid headings
    //         const paragraphs = body.paragraphs;
    //         paragraphs.load("items/style,name,items/text");
    //         await context.sync();
     
    //         // Insert a TOC title at the beginning of the document (or after a specific paragraph)
    //         const tocTitle = body.insertParagraph("Table of Contents", Word.InsertLocation.start);
    //         tocTitle.font.set({ bold: true, size: 14 });
    //         tocTitle.spaceAfter = 10;
     
    //         // Filter paragraphs to include valid headings
    //         const validHeadings = paragraphs.items.filter(
    //           (paragraph) =>
    //             (paragraph.style === "Heading 1" ||
    //              paragraph.style === "Heading 2" ||
    //              paragraph.style === "Heading 3") &&
    //             paragraph.text.trim() // Ignore empty headings
    //         );
     
    //         // Create TOC based on valid headings
    //         validHeadings.forEach((paragraph) => {
    //           const headingText = paragraph.text;
    //           let tocText = headingText; // Default TOC text is the heading text
    //           let indentation = 0;
     
    //           // Check for numbers in the heading text
    //           const containsNumber = /\d/.test(headingText);
     
    //           // Determine TOC entry format based on heading level and numbers
    //           if (paragraph.style === "Heading 1") {
    //             tocText = containsNumber ? headingText : headingText; // No additional numbering
    //           } else if (paragraph.style === "Heading 2") {
    //             indentation = 20; // Indent for Heading 2
    //             tocText = containsNumber ? headingText : headingText; // No additional numbering
    //           } else if (paragraph.style === "Heading 3") {
    //             indentation = 40; // Indent more for Heading 3
    //             tocText = containsNumber ? headingText : headingText; // No additional numbering
    //           }
     
    //           // Insert TOC entry after the title (or at the end of the document)
    //           const tocEntry = body.insertParagraph(tocText, Word.InsertLocation.end);
    //           tocEntry.styleBuiltIn = Word.Style.normal; // Apply "Normal" style
    //           tocEntry.leftIndent = indentation; // Set left indentation for subsections
    //           tocEntry.spaceAfter = 5;
 
               
 
    //         });
     
    //         await context.sync();
    //         console.log("Table of Contents added at the beginning.");
    //       });
    //     } catch (error) {
    //       console.error("Error inserting TOC: ", error);
    //     }
    //   };

  const extractContentarray = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const ul = doc.querySelector("ul");
    const items = Array.from(ul.querySelectorAll("li"));
    const result = [];
    let heading1 = true;

    items.forEach((item, index) => {
      const anchor = item.querySelector("a");
      const text = anchor.textContent.trim();
      const pageNumber = item.textContent.match(/\d+$/)?.[0];

      const structure = {
        text,
        link: anchor.href,
        page: pageNumber,
        heading: heading1 ? "Heading1" : "Heading2",
      };

      if (index > 5 && index <= 10) {
        heading1 = false;
      }

      result.push(structure);
    });

    return result;
  };
  const processContent = (htmlString) => {
    console.log("Original HTML String:", htmlString);
 
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
   const h1Tags = doc.querySelectorAll('h1');
   h1Tags.forEach((h1) => {
       const bold = document.createElement('b');
       bold.innerHTML = h1.innerHTML; // Transfer content
       h1.replaceWith(bold); // Replace <h1> with <b>
   });
   const h2Tags = doc.querySelectorAll('h2');
   h2Tags.forEach((h2) => {
       const section = document.createElement('b');
       section.innerHTML = h2.innerHTML; // Transfer content
       h2.replaceWith(bold); // Replace <h2> with <section>
   });
   
 
  const transformList = (ul, level = 1) => {
    if (!ul) return;
 
    console.log(`Transforming list at level ${level}`);
 
    const children = ul.children;
    Array.from(children).forEach((child) => {
      if (child.tagName === "LI") {
        console.log(`Found <li> at level ${level}:`, child.innerHTML);
 
        const newElement = document.createElement(level === 1 ? "h1" : "h2");
        newElement.innerHTML = child.innerHTML;
 
        console.log(`Replacing <li> with <${level === 1 ? "h1" : "h2"}>:`, newElement.outerHTML);
 
        // Replace the <li> tag with the new element
        child.replaceWith(newElement);
      } else if (child.tagName === "UL") {
        console.log("Found nested <ul>, going deeper");
        transformList(child, level + 1);
      }
    });
  };
 
  const rootUl = doc.querySelector("ul");
  transformList(rootUl);
 
  const transformedHTML = doc.body.innerHTML;
  console.log("Transformed HTML String:", transformedHTML);
 
  return transformedHTML;
  };
  
  
  
  
    const insertTOCFormat = async () => {
      try {
        await Word.run(async (context) => {
            // Check if there's a current selection
            const selection = context.document.getSelection();
            const htmlcontentvv = `
<h1>Table of Contents</h1>
<ul>
    <li><a href="#_Toc159870724">NORTHERN DISTRICT OF CALIFORNIA PROCEDURAL GUIDANCE FOR CLASS ACTION SETTLEMENTS: REFERENCE TABLE</a>..........................1</li>
    <li><a href="#_Toc159870725">NOTICE OF MOTION</a>.........................................9</li>
    <li><a href="#_Toc159870726">STATEMENT OF THE ISSUES TO BE DECIDED</a>..................12</li>
    <li><a href="#_Toc159870727">MEMORANDUM OF POINTS AND AUTHORITIES</a>....................12</li>
    <li><a href="#_Toc159870728">INTRODUCTION</a>...........................................12</li>
    <li><a href="#_Toc159870729">RELEVANT FACTUAL AND PROCEDURAL BACKGROUND</a>..........15</li>
    <ul>
        <li><a href="#_Toc159870730">Brief Summary of the Litigation</a>..................15</li>
        <li><a href="#_Toc159870731">Summary of the Mediation Efforts and Agreement to Settle</a>....22</li>
        <li><a href="#_Toc159870732">Summary of Changed Practices</a>.......................28</li>
    </ul>
    <li><a href="#_Toc159870733">SUMMARY OF THE PROPOSED SETTLEMENT</a>......................30</li>
    <ul>
        <li><a href="#_Toc159870734">The Settlement Provides Substantial Relief to the Class Members</a>...30</li>
        <li><a href="#_Toc159870736">The Settlement Class Definitions Differ Only Slightly from the Classes Defined in the Operative Complaint</a>...32</li>
        <li><a href="#_Toc159870737">The Settlement’s Release is Coextensive with the Ninth Circuit’s “identical factual predicate” Requirement</a>...33</li>
        <li><a href="#_Toc159870738">The Settlement Agreement Allows Counsel to Seek Fees and Costs and the Settlement Class Representatives to Seek Service Awards</a>...35</li>
    </ul>
    <li><a href="#_Toc159870739">THE COURT SHOULD CERTIFY THE SETTLEMENT CLASSES</a>......36</li>
    <ul>
        <li><a href="#_Toc159870740">The Settlement Classes Satisfy the Rule 23(a) Prerequisites</a>....36</li>
        <li><a href="#_Toc159870741">Numerosity</a>................................................37</li>
        <li><a href="#_Toc159870743">Typicality</a>...................................................
38</li>
        <li><a href="#_Toc159870744">Adequacy</a>...................................................
38</li>
    </ul>
    <li><a href="#_Toc159870745">Common issues of law and fact predominate</a>.........38</li>
    <li><a href="#_Toc159870746">Class treatment of Plaintiffs’ claims is superior</a>......39</li>
    <li><a href="#_Toc159870748">SETTLEMENT APPROVAL IS WARRANTED</a>................40</li>
    <ul>
        <li><a href="#_Toc159870749">The Strengths and Risks of Plaintiffs’ Case</a>...........................40</li>
        <li><a href="#_Toc159870755">Comparing the Strengths and Risks of Plaintiffs’ Claims</a>.........41</li>
    </ul>
    <li><a href="#_Toc159870762">Further Litigation Would be Risky, Expensive, Complex, and Lengthy</a>...50</li>
    <li><a href="#_Toc159870766">The Settlement is Informed by Extensive Discovery</a>................52</li>
    <li><a href="#_Toc159870775">The Proposed Notice Program, Settlement Administrator, and Process for Claims, Opt-Outs, and Objections Should Be Approved</a>...76</li>
    <ul>
        <li><a href="#_Toc159870776">The Proposed Notice Plan</a>....................76</li>
        <li><a href="#_Toc159870777">The Claims Process</a>.......................82</li>
    </ul>
    <li><a href="#_Toc159870781">CONCLUSION</a>............................................91</li>
</ul>
<h1>Table of Authorities</h1>
<ul>
    <li><i>Amchem Prods., Inc. v. Windsor</i>, 521 U.S. 591 (1997)..................................38</li>
    <li><i>Briseno v. Henderson</i>, 998 F.3d 1014 (9th Cir. 2021).......................................58</li>
    <li><i>Cotter v. Lyft, Inc.</i>, 193 F. Supp. 3d 1030 (N.D. Cal. 2016).............................33</li>
    <li><i>Eddings v. D.S. Services of America, Inc.</i>, No. 15-cv-02576-VC, 2016 WL 3390477 (N.D. Cal. May 20, 2016)....33</li>
    <li><i>Fraley v. Facebook, Inc.</i>, 966 F. Supp. 2d 939 (N.D. Cal. 2013)..............................59</li>
    <li><i>In re Google LLC St. View Elec. Commc'ns Litig.</i>, No. 10-MD-02184-CRB, 2020 WL 1288377 (N.D. Cal. Mar. 18, 2020)..............58</li>
    <li><i>In re Online DVD-Rental Antitrust Litig.</i>, 779 F.3d 934 (9th Cir. 2015)...............................40</li>
    <li><i>McDonald, et al. v. Kiloo A/S</i>, No. 3:17-cv-04344-JD (N.D. Cal. Apr. 12, 2021).................58</li>
    <li><i>Wolf v. Permanente Medical Group, Inc.</i>, No. 17-cv-05345-VC, 2018 WL 5619801 (N.D. Cal. Sept 14, 2018)......................58</li>
</ul>`;

            // Insert the provided HTML content at the current selection
            const updatedContent = processContent(htmlcontentvv);
            //const updatedContent = extractContentarray(htmlcontentvv);
            console.log(updatedContent);
           
     
                // Insert the provided HTML content at the current selection
                selection.insertHtml(updatedContent, Word.InsertLocation.replace);
                await context.sync();
     
                // Load all paragraphs in the document
                // const paragraphs = context.document.body.paragraphs;
                // paragraphs.load("items");
     
                // await context.sync();
     
                // // Iterate through the paragraphs and adjust alignment or apply Roman numeral formatting
                // paragraphs.items.forEach((para) => {
                //     if (para.text.includes("....")) { // Example placeholder for alignment
                //         para.alignment = Word.Alignment.right; // Align the paragraph to the right
                //     }
                // });
     
                // await context.sync();

            
           
     
 
            console.log("Content successfully appended and formatted in the Word document.");
        });
    } catch (error) {
        console.error("Error appending content to Word document:", error);
    }

    };
    const insertTOC = async () => {
        try {
          await Word.run(async (context) => {
            const body = context.document.body;
     
              // Load all paragraphs to identify headings and their properties (style, text, and numbering)
            const paragraphs = body.paragraphs;
            paragraphs.load("items/style,items/text,items/numbering,items/paragraphFormat");
            await context.sync();
 
            // Load all paragraphs to identify headings
            const validHeadings = paragraphs.items
            .filter((paragraph) => {
                const isHeading =
                    paragraph.style === "Heading 1" ||
                    paragraph.style === "Heading 2" ||
                    paragraph.style === "Heading 3";
                return isHeading && paragraph.text.trim() !== "";
            })
            .map((paragraph) => {
                // Get the text of the heading
                const headingText = paragraph.text;
 
                // Initialize numbering as "N/A"
                let numbering = "N/A";
 
                // Check if the paragraph has numbering applied (e.g., Roman numerals, decimals)
                if (paragraph.numbering) {
                    // If numbering is applied, get the numbering format
                    numbering = paragraph.numbering.format || "N/A";
                }
 
                // Initialize page number as "N/A"
                let pageNumber = "N/A";
 
               
 
                // Return the heading object with page number and numbering
                return {
                    text: headingText,
                    style: paragraph.style,
                    pageNumber: pageNumber,
                    numbering: numbering
                };
            });
     
            if (validHeadings.length === 0) {
              console.log("No valid headings found in the document.");
              return;
            }
     
           
            console.log(validHeadings);
            // to remove the contentr preceding the inroudtion
            const introIndex = validHeadings.findIndex(item => item.text === "INTRODUCTION");
 
            if (introIndex === -1) {
            console.error("Introduction not found in the content");
            return [];
            }
 
            // Filter content starting from "INTRODUCTION"
            const filteredContent = validHeadings.slice(introIndex);
 
            const finalfiltercontentrevers = filteredContent.reverse();
 
            // Reverse the order of the filtered content
            console.log(finalfiltercontentrevers)
            // Iterate through the valid headings
           
            finalfiltercontentrevers.forEach((paragraph) => {
                const headingText = paragraph.text;
                let tocText = headingText; // Default TOC text is the heading text
                let indentation = 0;
       
                // Check for numbers in the heading text
                const containsNumber = /\d/.test(headingText);
       
                // Determine TOC entry format based on heading level and numbers
                if (paragraph.style === "Heading 1") {
                tocText = containsNumber ? headingText : headingText; // No additional numbering
                } else if (paragraph.style === "Heading 2") {
                indentation = 20; // Indent for Heading 2
                tocText = containsNumber ? headingText : headingText; // No additional numbering
                } else if (paragraph.style === "Heading 3") {
                indentation = 40; // Indent more for Heading 3
                tocText = containsNumber ? headingText : headingText; // No additional numbering
                }
       
                // Insert TOC entry after the title (or at the end of the document)
                const tocEntry = body.insertParagraph(tocText, Word.InsertLocation.start);
                tocEntry.styleBuiltIn = Word.Style.normal; // Apply "Normal" style
                tocEntry.leftIndent = indentation; // Set left indentation for subsections
                tocEntry.spaceAfter = 5;
 
            });
            const tocTitle = body.insertParagraph("Table of Contents", Word.InsertLocation.start);
            tocTitle.font.set({ bold: true, size: 14 });
            tocTitle.spaceBefore = 10;
     
            await context.sync();
            console.log("Table of Contents with hyperlinks created successfully.");
          });
        } catch (error) {
          console.error("Error inserting TOC: ", error);
        }
      };
     
     
     
      // Helper function to convert numbers to Roman numerals
      const toRoman = (num) => {
        const romanMap = [
          [1000, "M"],
          [900, "CM"],
          [500, "D"],
          [400, "CD"],
          [100, "C"],
          [90, "XC"],
          [50, "L"],
          [40, "XL"],
          [10, "X"],
          [9, "IX"],
          [5, "V"],
          [4, "IV"],
          [1, "I"],
        ];
        let result = "";
        for (let [value, numeral] of romanMap) {
          while (num >= value) {
            result += numeral;
            num -= value;
          }
        }
        return result;
      };
     
   
    return (
        <div style={{ marginTop: "10px", textAlign: "center", position: "relative" }}>
            {/* <h1>Document Analysis</h1> */}
            <div style={{ marginBottom: "10px" }}>
                <label htmlFor="fileUpload">Upload Document:</label>
            </div>
            <div>
      <button onClick={insertTOC}>Add Table of Contents</button>
      <button onClick={insertTOCFormat}>Add Formated TOC</button>
    </div>
            <div style={{ position: "relative", display: "inline-block", marginBottom: "10px" }}>
                <input
                    type="file"
                    id="fileUpload"
                    onChange={handleFileUpload}
                    required
                    disabled={loading}
                    style={{ padding: "5px" }}
                />
                {loading && (
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 1,
                            background: "rgba(255, 255, 255, 0.8)",
                            borderRadius: "50%",
                            padding: "10px",
                        }}
                    >
                        <Spinner size="medium" />
                    </div>
                )}
            </div>
            <Button onClick={handleUploadAndSubmit} appearance="primary" disabled={loading}>
                Submit
            </Button>
            <div style={{ marginTop: "10px", color: message.includes("successful") ? "green" : "red" }}>
                {message}
            </div>
        </div>
    );
};
 
export default DocumentAnalysis;
 
 